import React, {useEffect, useState} from 'react';
import {
    useTheme,
    Box,
    Stack,
    Typography,
    TextField,
    Divider,
    Switch,
    Button,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent,
    DialogContentText,
    RadioGroup,
    Radio,
    FormControlLabel,
    FormControl,
    InputLabel,
    IconButton,
    Checkbox,
    Select,
    MenuItem
    // Fade,
    // IconButton,
    // Menu,
    // MenuItem,
} from "@mui/material";
import LinearProgress from '@mui/material/LinearProgress';
import EditIcon from '@mui/icons-material/Edit';
// import FormControl from '@mui/material/FormControl';
// import FormHelperText from '@mui/material/FormHelperText';
// import Input from '@mui/material/Input';
// import InputLabel from '@mui/material/InputLabel';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';

// import MenuIcon from '@mui/icons-material/Menu';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
// import SearchIcon from '@mui/icons-material/Search';
// import DirectionsIcon from '@mui/icons-material/Directions';

import {tokens} from "../../theme";
import appealsStore from '../../store/appealsStore';
import BillingService from "../../services/BillingService";
import SwitchService from '../../services/SwitchService';
// import UserResultElement from './UserResultElement';
import YaMap from '../YaMap/YaMap';
import { int2ip } from "../../utils/formatIpAddress";

const HostEdit = ({host=null, open, handleClose}) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [loading, setLoading] = useState(true);
    
    // const appealGroups = appealsStore.getAppealGroup();
    // const providers = appealsStore.getProviders();
    // const billings = appealsStore.getBillings()
    
    const descriptionElementRef = React.useRef(null);
    const [change, setChange] = useState(false)
    
    useEffect(() => {
        if (host) {
            setChange(false)
            // setProvider(providers.find(provider => provider.id === appeal.provider_id))
            // setBilling(billings.find(billing => billing.provider_id === appeal.provider_id))
            // switch(appeal.source_type) {
            //     case 'user':
            //         setAppealNameText(appeal.crm_object.login)
            //         break
            //     default: 
            //         setAppealNameText(appeal.source)
            //         setMobileTelephone(appeal.source)
            //         break
            // }
        }
        else {
            setChange(true)
            // setAppealNameText("")
        }
        
        setZbxHost(host ? host.zbx_host : "")
        setZbxName(host ? host.zbx_name : "")
        setZbxDescription(host ? host.zbx_description : "")
        setZbxLocation(host ? host.zbx_location : "")
        setZbxLocationLat(host ? host.zbx_location_lat : "")
        setZbxLocationLon(host ? host.zbx_location_lon : "")

    }, [host])

    const [zbxHost, setZbxHost] = useState("")
    const [errorZbxHost, setErrorZbxHost] = useState("")
    const handleChangeZbxHost = (event) => {
        setZbxHost(event.target.value)
        const pattern = /^[\p{L}\p{Emoji}]+$/u;
        if (!pattern.test(event.target.value)) {
            setErrorZbxHost("Incorrect input")
        }
        else {
            setErrorZbxHost("")
        }
    }

    const [zbxName, setZbxName] = useState("")
    const [errorZbxName, setErrorZbxName] = useState("")
    const handleChangeZbxName = (event) => {
        setZbxName(event.target.value)
        // const pattern = /^[\p{L}\p{Emoji}]+$/u;
        // if (!pattern.test(event.target.value)) {
        //     setErrorZbxName("Incorrect input")
        // }
        // else {
        //     setErrorZbxName("")
        // }
    }

    const [zbxDescription, setZbxDescription] = useState("")
    const [errorZbxDescription, setErrorZbxDescription] = useState("")
    const handleChangeZbxDescription = (event) => {
        setZbxDescription(event.target.value)
        const pattern = /^[\p{L}\p{Emoji}]+$/u;
        // if (!pattern.test(event.target.value)) {
        //     setErrorZbxDescription("Incorrect input")
        // }
        // else {
        //     setErrorZbxDescription("")
        // }
    }

    const [zbxLocation, setZbxLocation] = useState("")
    const [errorZbxLocation, setErrorZbxLocation] = useState("")
    const handleChangeZbxLocation = (event) => {
        setZbxLocation(event.target.value)
        const pattern = /^[\p{L}\p{Emoji}]+$/u;
        // if (!pattern.test(event.target.value)) {
        //     setErrorZbxLocation("Incorrect input")
        // }
        // else {
        //     setErrorZbxLocation("")
        // }
    }

    const [zbxLocationLat, setZbxLocationLat] = useState("")
    const [zbxLocationLon, setZbxLocationLon] = useState("")
    const handleChangeCoords = (coords) => {
        setZbxLocationLat(coords[0])
        setZbxLocationLon(coords[1])
        console.log(coords)
    }


    useEffect(() => {
        if (host) {
            setChange(false)
            if (zbxHost !== host.zbx_host) {
                setChange(true)
            }
            if (zbxName !== host.zbx_name) {
                setChange(true)
            }
            if (zbxDescription !== host.zbx_description) {
                setChange(true)
            }
            if (zbxLocation !== host.zbx_location) {
                setChange(true)
            }
            if (zbxLocationLat !== host.zbx_location_lat) {
                setChange(true)
            }
            if (zbxLocationLon !== host.zbx_location_lon) {
                setChange(true)
            }
        }
    }, [ host, zbxHost, zbxDescription, zbxName, zbxLocation, zbxLocationLat, zbxLocationLon] )

    // save
    const [errorMessage, setErrorMessage] = useState("")
    const handleSave = async () => {
        setLoading(false)
        setErrorMessage("")
        if (errorZbxHost || errorZbxName || errorZbxLocation || errorZbxDescription) {
            setErrorMessage("Error")
            setLoading(true)
            return
        }
        host.zbx_host = zbxHost
        host.zbx_name = zbxName
        host.zbx_description = zbxDescription
        host.zbx_location = zbxLocation
        host.zbx_location_lat = zbxLocationLat
        host.zbx_location_lon = zbxLocationLon
        try {
            const putHost = await SwitchService.putHost(host.network, host.ip, host)
            handleClose()
        } catch (e) {
            console.log(e);
            setErrorMessage("Error updating request.")
        } finally {
            setLoading(true)
        }
    }

    return (
        <Box>
            <Dialog
                open={open}
                onClose={handleClose}
                scroll={'body'}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogTitle id="scroll-dialog-title">
                    {host 
                        ?   <Typography variant="h5" sx={{ color: colors.greenAccent[500] }}>
                                {int2ip(host.ip)} ({host.mac})
                            </Typography>
                        :   <Typography variant="h5" sx={{ color: colors.greenAccent[500] }}>
                                New host
                            </Typography> 
                    }
                </DialogTitle>
                <DialogContent>
                    <DialogContentText
                        id="scroll-dialog-description"
                        ref={descriptionElementRef}
                        tabIndex={-1}
                        // p={5}
                    >
                        {/* <Divider /> */}
                        {/* Loading and errors */}
                        {!loading && <LinearProgress /> }
                        {errorMessage && <Typography>{errorMessage}</Typography>}
                        {/* Source of reference */}
                        {/* {setAppeal.is_open} */}
                        <Stack spacing={3}>
                            {/* Host */}
                            <Paper
                                component="form"
                                sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', }}
                            >
                                <Stack
                                    spacing={1}
                                    sx={{
                                        width: "100%",
                                        p: 1
                                    }}  
                                >
                                    {/* <Typography variant='subtitle2' pb={1} pt={1} sx={{ color: colors.greenAccent[500] }}></Typography> */}
                                    <TextField
                                        value={zbxHost}
                                        onChange={handleChangeZbxHost}
                                        required
                                        label="zbxHost"
                                        color='secondary'
                                        error={errorZbxHost}
                                        helperText={errorZbxHost}
                                        disabled
                                    />
                                    <TextField
                                        value={zbxName}
                                        onChange={handleChangeZbxName}
                                        required
                                        label="zbxName"
                                        color='secondary'
                                        error={errorZbxName}
                                        helperText={errorZbxName}
                                    />
                                    <TextField
                                        value={zbxDescription}
                                        onChange={handleChangeZbxDescription}
                                        required
                                        label="zbxDescription"
                                        color='secondary'
                                        error={errorZbxDescription}
                                        helperText={errorZbxDescription}
                                    />
                                    <TextField
                                        value={zbxLocation}
                                        onChange={handleChangeZbxLocation}
                                        required
                                        label="zbxLocation"
                                        color='secondary'
                                        error={errorZbxLocation}
                                        helperText={errorZbxLocation}
                                    />
                                    {zbxLocationLat && zbxLocationLon && <Typography>{zbxLocationLat}:{zbxLocationLon}</Typography>}
                                    <YaMap 
                                        center={[zbxLocationLat ? zbxLocationLat : 55.61956932823956, zbxLocationLon ? zbxLocationLon : 37.4737783227441]}
                                        coords={[zbxLocationLat ? zbxLocationLat : null, zbxLocationLon ? zbxLocationLon : null]}
                                        handleChangeCoords={handleChangeCoords}
                                    />
                                </Stack>
                            </Paper>
                            
                            {/* END new subscriber */}

                            {/* Groups */}
                            {/* <Paper
                                component="form"
                                sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 320 }}
                            >
                                <Stack>
                                    <Typography variant='subtitle2' pb={1} sx={{ color: colors.greenAccent[500] }}>
                                        Передать обращение другой группе.
                                    </Typography>
                                    <RadioGroup row defaultValue={groupId}>
                                        {appealGroups.map((el) => {
                                            if (el.provider_id !== appeal.provider_id) {
                                                return
                                            }
                                            return  <FormControlLabel
                                                        value={el.id}
                                                        // checked={el.id == groupId ? true : false}
                                                        control={<Radio color='secondary' onChange={handleChangeGroup}/>} 
                                                        label={el.name}
                                                    />
                                        })}
                                    </RadioGroup>
                                </Stack>
                            </Paper> */}
                            {/* Groups */}

                            {/* Comment */}
                            {/* {change && (
                                <TextField
                                    error={errorMessageText && true}
                                    multiline
                                    // label="Comment"
                                    sx={{ ml: 1, flex: 1 }}
                                    placeholder="Введите сообщение...."
                                    value={messageText}
                                    color='secondary'
                                    onChange={handleChangeMessageText}
                                    // inputProps={{ 'aria-label': 'search google maps' }}
                                    helperText={errorMessageText && errorMessageText}
                                    variant="standard"
                                />
                            )} */}
                        </Stack>
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    {change && (
                        <Button onClick={handleSave} color="primary">
                            Save
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        </Box>
    );
}
export default HostEdit;